export default "__VITE_ASSET__nswRphuJ__"